/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_Column_AccessInputs */

const en_landing_footer_column_access = /** @type {(inputs: Landing_Footer_Column_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access`)
};

/**
* | output |
* | --- |
* | "Access" |
*
* @param {Landing_Footer_Column_AccessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_column_access = /** @type {((inputs?: Landing_Footer_Column_AccessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_Column_AccessInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_column_access(inputs)
});